import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-infinite-scroll-component',
  templateUrl: './custom-infinite-scroll-component.component.html',
  styleUrls: ['./custom-infinite-scroll-component.component.scss'],
})
export class CustomInfiniteScrollComponentComponent implements OnInit {
  @Input() loading!: boolean;
  @Input() hasMoreData!: boolean;
  @Input() items = [];
  @Input() loadMore?: () => void;

  constructor() {}

  ngOnInit(): void {}

  triggerLoadMore(): void {
    if (this.loading) return;
    if (typeof this.loadMore !== 'function') return;
    this.loadMore();
  }
}
